export default "__VITE_PUBLIC_ASSET__5c60af45__"